import service from "../libs/request.js";

// 获取给院长写信
var getDeanLetter = function(postdata, callback) {
  service.get({
    url: "/contractus/getDeanLetter",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取来信统计列表;
var getLetterCountList = function(postdata, callback) {
  service.get({
    url: "/contractus/getLetterCountList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取来信统计;
var getLetterCountInfo = function(postdata, callback) {
  service.get({
    url: "/contractus/getLetterCountInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取来信选登列表;
var getLetterSelectedList = function(postdata, callback) {
  service.get({
    url: "/contractus/getLetterSelectedList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取来信选登;
var getLetterSelectedInfo = function(postdata, callback) {
  service.get({
    url: "/contractus/getLetterSelectedInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取纪检监察列表
var getLetterInspectionList = function(postdata, callback) {
  service.get({
    url: "/contractus/getLetterInspectionList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取纪检监察
var getLetterInspectionInfo = function(postdata, callback) {
  service.get({
    url: "/contractus/getLetterInspectionInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取来信回复列表
var getLetterReplyList = function(postdata, callback) {
  service.get({
    url: "/contractus/getLetterReplyList",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

// 获取来信回复
var getLetterReplyInfo = function(postdata, callback) {
  service.get({
    url: "/contractus/getLetterReplyInfo",
    params: postdata,
    loading: true,
    success: function(res) {
      callback(res);
    },
  });
};

export default {
  getDeanLetter,
  getLetterCountList,
  getLetterCountInfo,
  getLetterSelectedList,
  getLetterSelectedInfo,
  getLetterInspectionList,
  getLetterInspectionInfo,
  getLetterReplyList,
  getLetterReplyInfo,
};
